<!--
Copyright 2021 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license. See LICENSE.md in the project root for license information.
-->

<crucible-dialog
  [dialogTitle]="'Export ' + (typeString | titlecase) + ': ' + name"
  [form]="form"
  submitLabel="Export"
  [submitDisabled]="!form.valid"
  (cancel)="cancel()"
  (submit)="export()"
>
  <div crucibleDialogContent [formGroup]="form">
    @if (isArchiveable) {
      <mat-form-field>
        <mat-label>Archive Type</mat-label>
        <mat-select formControlName="archiveType" cdkFocusInitial>
          @for (archiveType of archiveTypes; track archiveType) {
            <mat-option [value]="archiveType">
              {{ archiveType }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    }

    <div class="toggle-row">
      <mat-label>Include Ids</mat-label>
      <mat-slide-toggle
        formControlName="includeIds"
        matTooltip="Append Ids to Directory names to be optionally preserved on import"
      ></mat-slide-toggle>
    </div>
  </div>
</crucible-dialog>
